import chunk from 'lodash/chunk'

export const arrToKeyValue = (arr: unknown[]) =>
  Array.isArray(arr) &&
  chunk(arr, 2).map(pair => {
    const [key, value] = pair
    return { key, value }
  })
